import axios from "axios";
import { TCertification } from "../types";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { IGeneralProps } from "types";

export const QUERY_KEY_FOR_SINGLE_CERTIFICATION = "get-single-certification";

export const getSingleCertification = async (
  props: IGeneralProps
): Promise<TCertification> => {
  const id = props.id;
  const url = `${END_POINT.BASE_URL}/v1/get-certification/${id}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, config);
  const item = res.data;

  const record = item?.data ?? item;

  const data: TCertification = {
    id: record.id,
    talent_id: record.talent_id,
    title: record.title,
    certification_id: record.certification_id,
    description: record.description,
    issuer: record.issuer,
    link: record.link,
    file_path: record.file_path,
    issued_date: record.issued_date ?? record.startDate,
    expiry_date: record.expiry_date ?? record.endDate,
  };
  return data;
};

export const useGetSingleCertification = ({
  id,
  token,
  enabled = true,
}: IGeneralProps & { enabled?: boolean }) => {
  const queryData = useQuery(
    [QUERY_KEY_FOR_SINGLE_CERTIFICATION, id],
    () =>
      getSingleCertification({
        id,
        token,
      }),
    {
      enabled: Boolean(token && id && enabled),
    },
  );

  return queryData;
};
